import { render, staticRenderFns } from "./uploadAttachment.vue?vue&type=template&id=3df640e4&scoped=true"
import script from "./uploadAttachment.vue?vue&type=script&lang=js"
export * from "./uploadAttachment.vue?vue&type=script&lang=js"
import style0 from "./uploadAttachment.vue?vue&type=style&index=0&id=3df640e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df640e4",
  null
  
)

export default component.exports